var _rect, _g, _rect2, _g2, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 27,
    viewBox: "0 0 53 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 24,
    rx: 12,
    fill: "url(#paint0_linear_1305_13687)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1305_13687)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5733 20.322C37.9419 20.8855 39.4283 21.1028 40.901 20.9547C42.3736 20.8065 43.7869 20.2975 45.0158 19.4726C46.2447 18.6478 47.2512 17.5326 47.9462 16.2258C48.6412 14.9191 49.0031 13.4611 49 11.981C48.9969 10.501 48.6289 9.04452 47.9284 7.74068C47.228 6.43685 46.2169 5.32588 44.9845 4.50618C43.7522 3.68648 42.3367 3.18336 40.8635 3.04137C39.3902 2.89938 37.9047 3.12292 36.5385 3.69217C42.1802 7.79145 42.1968 16.1977 36.5733 20.322Z",
    fill: "#FFFEF7"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1305_13687",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 52,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 24,
    rx: 12,
    fill: "url(#paint1_linear_1305_13687)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1305_13687)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7499 14H12.7999H6.99988C5.34303 14 3.99988 12.6569 3.99988 11V10.4C3.99988 8.74314 5.34302 7.4 6.99988 7.4H7.4099C7.9195 4.88954 10.139 3 12.7999 3C15.0557 3 16.9943 4.35802 17.8427 6.3011C19.9261 6.3504 21.5999 8.05473 21.5999 10.15C21.5999 10.1944 21.5991 10.2387 21.5976 10.2828C21.5991 10.3217 21.5999 10.3608 21.5999 10.4V11C21.5999 12.6569 20.2567 14 18.5999 14H17.7499Z",
    fill: "url(#paint2_linear_1305_13687)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.9175 26.9438C23.2391 28.3084 21.0735 29.0871 18.7424 28.9853C17.2423 28.9198 15.8423 28.4969 14.6208 27.8025C13.3603 29.1621 11.533 29.98 9.53562 29.8927C5.92603 29.735 3.12771 26.6811 3.2854 23.0715C3.44309 19.4619 6.49707 16.6636 10.1067 16.8213C10.2327 16.8268 10.3577 16.8358 10.4817 16.8483C11.7685 13.1122 15.393 10.504 19.5419 10.6852C23.6918 10.8665 27.0757 13.7822 28.0309 17.6176C28.1551 17.6143 28.2802 17.6153 28.4063 17.6208C31.2939 17.7469 33.5326 20.1901 33.4064 23.0778C33.2803 25.9654 30.8371 28.2041 27.9494 28.0779C26.7998 28.0277 25.7531 27.6103 24.9175 26.9438Z",
    fill: "url(#paint3_linear_1305_13687)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 15L35.1105 15.2987C35.2118 15.5724 35.4276 15.7882 35.7013 15.8895L36 16L35.7013 16.1105C35.4276 16.2118 35.2118 16.4276 35.1105 16.7013L35 17L34.8895 16.7013C34.7882 16.4276 34.5724 16.2118 34.2987 16.1105L34 16L34.2987 15.8895C34.5724 15.7882 34.7882 15.5724 34.8895 15.2987L35 15Z",
    fill: "#FFFEF6",
    fillOpacity: 0.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 10L27.7456 10.6636C27.8468 10.9373 28.0627 11.1532 28.3364 11.2544L29 11.5L28.3364 11.7456C28.0627 11.8468 27.8468 12.0627 27.7456 12.3364L27.5 13L27.2544 12.3364C27.1532 12.0627 26.9373 11.8468 26.6636 11.7456L26 11.5L26.6636 11.2544C26.9373 11.1532 27.1532 10.9373 27.2544 10.6636L27.5 10Z",
    fill: "#FFFEF6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5L18.1105 5.29867C18.2118 5.57239 18.4276 5.7882 18.7013 5.88948L19 6L18.7013 6.11052C18.4276 6.2118 18.2118 6.42761 18.1105 6.70133L18 7L17.8895 6.70133C17.7882 6.42761 17.5724 6.2118 17.2987 6.11052L17 6L17.2987 5.88948C17.5724 5.7882 17.7882 5.57239 17.8895 5.29867L18 5Z",
    fill: "#FFFEF6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 3L31.7456 3.66362C31.8468 3.93734 32.0627 4.15315 32.3364 4.25444L33 4.5L32.3364 4.74556C32.0627 4.84685 31.8468 5.06266 31.7456 5.33638L31.5 6L31.2544 5.33638C31.1532 5.06266 30.9373 4.84685 30.6636 4.74556L30 4.5L30.6636 4.25444C30.9373 4.15315 31.1532 3.93734 31.2544 3.66362L31.5 3Z",
    fill: "#FFFEF6",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1305_13687",
    x: 32.5385,
    y: 1,
    width: 20.4615,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1305_13687"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1305_13687",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1305_13687",
    x1: 3.28408e-7,
    y1: 11.5,
    x2: 52,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.106006,
    stopColor: "#3C58C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544473,
    stopColor: "#615096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988128,
    stopColor: "#8750F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1305_13687",
    x1: 3.28408e-7,
    y1: 11.5,
    x2: 52,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00673288,
    stopColor: "#CD792B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52832,
    stopColor: "#A689FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89A2FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1305_13687",
    x1: 12.7999,
    y1: 3,
    x2: 12.7999,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1305_13687",
    x1: 18.8884,
    y1: 10.6567,
    x2: 18.0319,
    y2: 30.2639,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDark);
export default __webpack_public_path__ + "static/media/dark.45a4175bf7fe65a9daa7cd46be706827.svg";
export { ForwardRef as ReactComponent };